import { getAuth } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { fbProvider, glProvider, signIn, twProvider } from '../auth';
import { setCrtUser, setMessage } from '../store';
import '../styles/auth.scss';
import logo from '../styles/heyart-logo-one-line.svg';

function SignInScreen() {
  const dispatch = useDispatch()

  function handleSignIn(provider) {
    signIn(provider)
      .then(() => {
        // wait until we udate the profile,
        // then reload to display the picture
        getAuth().currentUser
          .reload()
          .then(() => dispatch(setCrtUser(getAuth().currentUser.toJSON())))
      })

      .catch(err => {
        console.log(err)
        dispatch(setMessage({
          text: 'Something went wrong while signing you in. Please try again!',
          status: 'error'
        }))
      })
  }

  return (
    <div id="sign-in" className="auth-screen full-screen">
      <h1 className='auth-logo'>
        <img src={logo} />
      </h1>
      <div className='auth-form'>
        <h3 className='title'>Sign In</h3>

        <a className="btn btn-block btn-social btn-twitter" onClick={() => handleSignIn(twProvider)}>
          <i className="bi bi-twitter"></i>Sign In with Twitter
        </a>
        <a className="btn btn-block btn-social btn-facebook" onClick={() => handleSignIn(fbProvider)}>
          <i className="bi bi-facebook"></i>Sign In with Facebook
        </a>
        <a className="btn btn-block btn-social btn-google" onClick={() => handleSignIn(glProvider)}>
          <i className="bi bi-google"></i>Sign In with Google
        </a>
      </div>
    </div>
  )
}

export default SignInScreen;
